import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-play-circle",
  "use": "icon-s-play-circle-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-play-circle\"><path d=\"M11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11m0-2a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-1.737-3.205A1.5 1.5 0 0 1 7 15.503V6.5a1.5 1.5 0 0 1 2.276-1.284l7.528 4.554a1.5 1.5 0 0 1-.013 2.575zM9 7.387v7.24l6.053-3.579z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol